import InstrumentIcon from "../../../../components/instrument-icon";
import React, {useEffect, useState} from "react";
import associateServices from "../../../../services";
import Big from "big.js";
import Loading from "../../../../components/loading";
import {useTranslation} from "react-i18next";
import FormButton from "../../../../components/form-button";
import './index.css'
import {decrypt, encrypt} from "../../../../helpers/encryption";
import {useSelector} from "react-redux";
import {toast} from "react-toastify";
import InformationToast from "../../../../components/toast/InformationToast";

const RakeBackModal = () => {
    const {t} = useTranslation()
    const [rakebacks, setRakebacks] = useState([])
    const [loading, setLoading] = useState(true)
    const [submitting, setSubmitting] = useState(false)
    const [rates, setRates] = useState({})
    const {selectedFiat} = useSelector(state => state.authenticationReducer)
    const {symbols} = useSelector(state => state.globalReducer)

    useEffect(() => {

        if (selectedFiat) {
            const handleFiatRates = e => {
                const data = decrypt(e)
                setRates(data)
            }
            window?.tcpSocket?.emit('fiat:rate', encrypt({
                currency: selectedFiat
            }))

            window?.tcpSocket?.on('fiat:rates', handleFiatRates)


        }

    }, [selectedFiat])

    const getRakebacks = () => {
        associateServices.getRakebacks({}).then(res => {
            setRakebacks(res?.data || [])
            setLoading(false)
        })
    }
    useEffect(() => {
        setLoading(true)
        getRakebacks()
    }, [])

    const handleRakeBack = () => {
        if (submitting)
            return false;

        setSubmitting(true)
        associateServices.rakeback({})
            .then(res => {
                setSubmitting(false)
                if (res?.status !== 200)
                    return toast(<InformationToast
                        icon={'ti-error-404'}
                        title={'...'}
                        message={t(`api-notifications.${res?.errors}`)}
                    />)

                getRakebacks()
            })
    }

    const getDisplayCurrency = (rakeback) => {

        if (!selectedFiat)
            return Big(rakeback?.wallet_amount || 0).toFixed(8)

        return `${symbols[selectedFiat]} ${Big(rakeback.wallet_amount || 0).times(1 / (rates[rakeback.wallet_currency] || 1)).toFixed(2)}`
    }
    return (
        <div>
            {
                loading ? <Loading/> :
                    <>
                        <div
                            className="form__group d-flex flex-column align-items-center justify-content-center flex-wrap gap-4">
                            {
                                rakebacks?.length >= 1 ?
                                    <>
                                        <h4 className="form__group text-center align-items-center">{t('rakeback.title')}</h4>

                                        <div className="rakeback-item-wrapper d-flex align-items-center gap-2">
                                            {
                                                rakebacks?.map(rakeback => (
                                                    <div
                                                        key={rakeback.id}
                                                        className="d-flex align-items-center justify-content-center gap-1">
                                                        <span className='rakeback-item-amount'>
                                                            {getDisplayCurrency(rakeback)}
                                                        </span>
                                                        <InstrumentIcon code={rakeback?.wallet_currency}/>
                                                    </div>
                                                ))
                                            }
                                        </div>


                                        <FormButton
                                            onClick={handleRakeBack}
                                            label={t('rakeback.button')}
                                            loading={submitting}
                                            disabled={submitting}
                                        />
                                    </>
                                    : <p>{t('rakeback.none-yet')}</p>
                            }
                        </div>

                    </>

            }

            <div className="form__cellar">
                <p className="full text-center">
                    {t('rakeback.description')}
                </p>
            </div>


        </div>
    )

}


export default RakeBackModal
